export default __webpack_public_path__ + "static/media/4.0f1d6e7c.jpg";